import { SnackBarService } from "src/app/services/common/snackBar.service";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange
} from "@angular/material";
import * as moment from "jalali-moment";
//import * as momenten from "moment";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngstack/translate";

import { IBranch } from "src/app/interfaces/branch";
import { IPlacementType } from "src/app/interfaces/placementType";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IPlacementTimeSheetGetDateList } from "src/app/interfaces/placement-timeSheet-GetDateList";
import { PlacementTypeService } from "src/app/services/http/business/placement/placement-type.service";
import { PlacementTiemSheetService } from "./../../../../services/http/business/placement/placement-tiem-sheet.service";
import { IPlacementTimeSheet } from "src/app/interfaces/placementTimeSheet";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { environment } from "src/environments/environment";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { HttpHeaders } from "@angular/common/http";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-time-sheet-entry",
  templateUrl: "./time-sheet-entry.component.html",
  styleUrls: ["./time-sheet-entry.component.css"],
  providers: [ErrorsService]
})
export class TimeSheetEntryComponent implements OnInit, OnDestroy {
  param: any;
  errorList: IError[] = [];
  minDate: Date;
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  errors = new Array();
  compnayList: ICompany;
  branchList: IBranch[];
  branchEncryptId: string;
  holidayList: any;
  placementTypeId: number;
  hidePlacementType: boolean = true;
  hideDatePlacement: boolean = true;
  placementTypeList: IPlacementType[];
  PlacementDateList: IPlacementTimeSheetGetDateList[];
  constructor(
    private fb: FormBuilder,
    private bidService: BIDService,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private calendarService: CalendarService,
    private holdingService: HoldingService,
    private placementTypeService: PlacementTypeService,
    public dialogRef: MatDialogRef<TimeSheetEntryComponent>,
    private plcaementTimeSheetService: PlacementTiemSheetService,
    @Inject(MAT_DIALOG_DATA) public data: IPlacementTimeSheet
  ) {
    debugger
    if (data) {
      this.loadPlacementType(this.data.BranchEncryptId);
      debugger
      if (this.isOwner)
        this.bidService.setBID(this.data.BranchEncryptId);
      this.loadPlacementDate(+data.PlacementTypeId);
    }
  }
  ngOnInit() {
    this.checkOwner();
    //this.bidService.removeBID();
    this.createForm();
    this.minDate = new Date();
    this.getHolidayTypeList();
    //this.minDate.setDate(this.minDate.getDate());
  }

  setCid(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    if (this.isOwner) {
      //this.bidService.removeBID();
      this.branchList = null;
    }

    // this.bidService.removeBID();
    this.getBranchList(e.value);
    this.getHolidayTypeList();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        //this.bidService.removeBID();
        this.getCompanyList();
        // this.bidService.setBID("");
      }
      else {
        this.loadPlacementTypeDirect(this.bidService.getBID());
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  getHolidayTypeList() {
    this.calendarService.calendarHolidayList().subscribe(res => {
      this.holidayList = res.DataList;
    });
  }

  createForm() {
    this.form = this.fb.group({
      BranchEncryptId: [
        null,
        Validators.compose([Validators.required])
      ],
      CalendarHolidayId: [
        null,
        Validators.compose([Validators.required])
      ],
      PlacementTypeId: [
        this.data && this.data.PlacementTypeId
          ? this.data.PlacementTypeId
          : null,
        Validators.compose([Validators.required])
      ],
      TeacherCount: [
        this.data && this.data.TeacherCount ? this.data.TeacherCount : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(50)
        ])
      ],
      // PlacementDate: [
      //   this.data && this.data.PlacementDate ? this.data.PlacementDate : null],
      StartDate: [null],
      EndDate: [
        null ? this.data.PlacementDate : null,
        this.data && this.data.PlacementDate ? null : Validators.compose([Validators.required])
      ],
      TimeStart: [
        this.data && this.data.TimeStart ? this.data.TimeStart : null,
        Validators.compose([Validators.required])
      ],
      TimeEnd: [
        this.data && this.data.TimeEnd ? this.data.TimeEnd : null,
        Validators.compose([Validators.required])
      ],
      Id: [
        this.data && this.data.Id ? this.data.Id : 0,
        Validators.compose([Validators.required])
      ]
    });

    if (!this.isOwner) {
      debugger;
      this.form.controls['BranchEncryptId'].setValue(this.bidService.getBID())
    }
    if (this.data) {
      debugger;
      this.form.controls['BranchEncryptId'].setValue(this.data.BranchEncryptId)
    }
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchList = [];
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.form.controls["BranchEncryptId"].patchValue(null)
        this.branchList = res.DataList;
        this.hidePlacementType = false;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementType(e) {
    if (this.isOwner)
      this.bidService.setBID(e)
    this.branchEncryptId = e;
    this.placementTypeService.list(0, 0).subscribe(
      res => {
        this.placementTypeList = res.DataList;
      },
      () => {
        this.placementTypeList = null;
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementTypeDirect(e) {
    debugger;
    this.branchEncryptId = e;
    this.placementTypeService.list(0, 0).subscribe(
      res => {
        this.placementTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementDate(placementTypeId: number) {
    debugger;
    var data: IPlacementTimeSheetGetDateList = {
      BranchEncryptId: this.branchEncryptId,
      PlacementTypeId: placementTypeId
    };
    this.plcaementTimeSheetService.GetDateList(data).subscribe(
      res => {
        this.hideDatePlacement = false;
        this.PlacementDateList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(data: any) {
    this.errors = new Array();
    //data.CalendarHolidayId = 5044;
    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    //data.StartDate = momenten().format(environment.dateFormat);

    if (this.data && this.data.Id !== 0) {
      data.PlacementDate = this.data.PlacementDate;
      data.PlacementTypeId = +data.PlacementTypeId;
      this.plcaementTimeSheetService.edit(data).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.plcaementTimeSheetService.add(data).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }
  ngOnDestroy(): void {
    // if (this.isOwner)
    //   this.bidService.setBID("");
  }
}
